import { render } from "./cross.svg?vue&type=template&id=31dba465?inline"
const script = {}
script.render = render

export default script